var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRegistration = function SvgRegistration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 30,
    width: 30,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 40v-4.7q0-1.7.85-3.125T7.4 30q3.6-1.6 6.6-2.3 3-.7 6-.7 1.45 0 3.075.175 1.625.175 3.325.625l-2.45 2.45q-1-.1-1.975-.175Q21 30 20 30q-2.9 0-5.275.525Q12.35 31.05 8.6 32.7q-.85.4-1.225 1.15Q7 34.6 7 35.3V37h15.95l3 3Zm27.25.8-7.05-7.05 2.1-2.1 4.95 4.95L41.9 25.95l2.1 2.1ZM20 23.9q-3.3 0-5.4-2.1-2.1-2.1-2.1-5.4 0-3.3 2.1-5.4 2.1-2.1 5.4-2.1 3.3 0 5.4 2.1 2.1 2.1 2.1 5.4 0 3.3-2.1 5.4-2.1 2.1-5.4 2.1ZM22.95 37ZM20 20.9q1.95 0 3.225-1.275Q24.5 18.35 24.5 16.4q0-1.95-1.275-3.225Q21.95 11.9 20 11.9q-1.95 0-3.225 1.275Q15.5 14.45 15.5 16.4q0 1.95 1.275 3.225Q18.05 20.9 20 20.9Zm0-4.5Z"
  })));
};

export default SvgRegistration;